module.exports = __webpack_public_path__ + "img/switch-horizontal-01.532962c5.svg";